import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { customColors, CustomColors } from "../../../styles/CustomColors";
import { useState } from "react";

interface ProductCardProps {
  title: string;
  image: string;
  altText: string;
  singleLink?: { text: string; url: string; ariaLabel: string };
  links?: Array<{ text: string; url: string; ariaLabel: string }>;
  colors?: CustomColors;
}

const ProductsCard = ({
  title,
  image,
  altText,
  singleLink,
  links,
  colors = customColors,
}: ProductCardProps) => {
  const [clickedLinks, setClickedLinks] = useState<string[]>([]);

  const handleLinkClick = (url: string) => {
    if (!clickedLinks.includes(url)) {
      setClickedLinks((prev) => [...prev, url]);
    }
  };

  return (
    <Grid
      container
      // role="region"
      // aria-labelledby="most-efficient-products"
      // aria-label="most effiencient products"
      marginBottom={{ xs: "1.875rem", sm: "1.875rem", md: "4rem" }}
      sx={{ justifyContent: "center" }}
    >
      <Card
        sx={{
          maxWidth: 345,
          boxShadow: 0,

          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
        role="region"
        aria-labelledby={`${title.replace(/\s/g, "-")}-title`}
        aria-describedby={`${title.replace(/\s/g, "-")}-description`}
      >
        <CardMedia
          component="img"
          src={image}
          alt={altText}
          height="200"
          sx={{ objectFit: "cover", width: "center", alignItems: "center" }}
        />
        <CardContent
          sx={{
            marginBottom: "0",
            width: "100%",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          {/* if there is a single link, render it as a title  */}
          {singleLink ? (
            <Typography id={`${title.replace(/\s/g, "-")}-title`} variant="h5">
              <Link
                href={(singleLink.url.startsWith('http') ? singleLink.url : import.meta.env.VITE_ENERGYSTARGOV + singleLink.url)}
                sx={{
                  color: colors.skyBlueBg,
                  textDecoration: "underline",
                  "&:hover": {
                    textDecoration: "none",
                  },
                }}
                aria-label={`Link to ${singleLink.text} for ${title}`}
              >
                {title}
              </Link>
            </Typography>
          ) : (
            <Typography id={`${title.replace(/\s/g, "-")}-title`} variant="h5">
              {title}
            </Typography>
          )}
          {/* render links if multiple links  */}
          {links && (
            <Box id={`${title.replace(/\s/g, "-")}-description`} mt={2}>
              {links.map((link, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  fontWeight="bolder"
                  lineHeight="1.5"
                  sx={{
                    mb: 3,
                    fontSize: "1rem",
                    color: colors.oceanBlueBg,
                    outline: "2px solid rgba(0, 0, 0, 0)",
                    outlineOffset: "2px",
                  }}
                >
                  <Link
                    href={(link.url.startsWith('http') ? link.url : import.meta.env.VITE_ENERGYSTARGOV + link.url)}
                    sx={{
                      color: clickedLinks.includes((link.url.startsWith('http') ? link.url : import.meta.env.VITE_ENERGYSTARGOV + link.url))
                        ? colors.skyBlueBg
                        : colors.oceanBlueBg,
                      textDecoration: "underline",
                      "&:hover": { color: colors.skyBlueBg },
                    }}
                    aria-label={`Link to ${link.text} for ${title}`}
                    onClick={() => handleLinkClick((link.url.startsWith('http') ? link.url : import.meta.env.VITE_ENERGYSTARGOV + link.url))}
                  >
                    {link.text}
                  </Link>
                </Typography>
              ))}
            </Box>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ProductsCard;
